import React, { useEffect, useRef, useState } from 'react';
import './CollaborationPlan.css';

const CollaborationPlan = ({ onOpenModal }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const stepRefs = useRef([]);
  const [visibleSteps, setVisibleSteps] = useState([]);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: isMobile ? '0px' : '-120px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const observers = [];
    
    stepRefs.current.forEach((step, index) => {
      if (step) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setVisibleSteps(prev => {
                if (!prev.includes(index)) {
                  return [...prev, index];
                }
                return prev;
              });
            }
          },
          { threshold: 0.1, rootMargin: isMobile ? '0px' : '-80px' }
        );
        
        observer.observe(step);
        observers.push(observer);
      }
    });

    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, []);

  return (
    <section id="collaboration" className={`collaboration-plan ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
      <div className="collaboration-container">
        <h2 className={`section-title fade-in-up ${isVisible ? 'visible' : ''}`}>
          On avance <span className="highlight-text">ensemble</span>,<br />étape par étape
        </h2>
        
        <div className="workflow">
          {/* Étapes initiales */}
          <div 
            ref={el => stepRefs.current[0] = el}
            className={`workflow-step fade-in-up ${visibleSteps.includes(0) ? 'visible' : ''}`}
          >
            <div className="step-number">1</div>
            <h3 className="step-title">Audit de vos besoins</h3>
            <p className="step-description">Discussion approfondie sur vos objectifs</p>
            <button onClick={onOpenModal} className="step-cta-button">
              <img src="/photo/equipe/photo-cv-entier.png" alt="" className="step-cta-avatar" />
              <span className="button-text">
                <span className="text-default">Appel découverte</span>
                <span className="text-hover">On est partis ?</span>
              </span>
            </button>
          </div>
          
          <div 
            ref={el => stepRefs.current[1] = el}
            className={`workflow-arrow fade-in-up ${visibleSteps.includes(1) ? 'visible' : ''}`}
          >↓</div>
          
          <div 
            ref={el => stepRefs.current[2] = el}
            className={`workflow-step fade-in-up ${visibleSteps.includes(2) ? 'visible' : ''}`}
          >
            <div className="step-number">2</div>
            <h3 className="step-title">Développement et intégration</h3>
            <p className="step-description">Implémentation dans vos systèmes</p>
          </div>
          
          <div 
            ref={el => stepRefs.current[3] = el}
            className={`workflow-arrow fade-in-up ${visibleSteps.includes(3) ? 'visible' : ''}`}
          >↓</div>
          
          {/* Point de décision */}
          <div 
            ref={el => stepRefs.current[6] = el}
            className={`decision-point scale-in ${visibleSteps.includes(6) ? 'visible' : ''}`}
          >
            <div className="decision-diamond">
              <p>Disposez-vous d'une équipe technique ?</p>
            </div>
          </div>
          
          {/* Séparation en deux branches */}
          <div className="workflow-branches">
            {/* Branche NON */}
            <div 
              ref={el => stepRefs.current[7] = el}
              className={`branch branch-left fade-in-left ${visibleSteps.includes(7) ? 'visible' : ''}`}
            >
              <div className="branch-label">NON</div>
              <div className="workflow-arrow">↓</div>
              <div className="workflow-step branch-step">
                <div className="step-number">4</div>
                <h3 className="step-title">Abonnement maintenance</h3>
                <p className="step-description">Entretien continu de vos systèmes</p>
              </div>
            </div>
            
            {/* Branche OUI */}
            <div 
              ref={el => stepRefs.current[8] = el}
              className={`branch branch-right fade-in-right ${visibleSteps.includes(8) ? 'visible' : ''}`}
            >
              <div className="branch-label">OUI</div>
              <div className="workflow-arrow">↓</div>
              <div className="workflow-step branch-step">
                <div className="step-number">4</div>
                <h3 className="step-title">Passation aux équipes</h3>
                <p className="step-description">Transfert du système en interne</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollaborationPlan;
